<div [formGroup]="form">
  <div class="row">
    <div class="col-12 mb-3">
      <div class="d-flex flex-wrap">
        <div class="mr-4">
          <label>Data de start</label>

          <app-date-picker
            [selectedDate]="form.value.data_start_monta"
            (dateChanged)="dataMontaChange($event)"
            [invalid]="field_errors['data_start_monta']"
            [disabled]="disabledFields['data_start_monta']"
          >
          </app-date-picker>
          <div class="text-danger">
            {{ field_errors["data_start_monta"] }}
          </div>
        </div>

        <div>
          <label>Data de final</label>

          <app-date-picker
            [selectedDate]="form.value.data_final_monta"
            (dateChanged)="dataEndMontaChange($event)"
            [invalid]="field_errors['data_final_monta']"
            [disabled]="disabledFields['data_final_monta']"
          >
          </app-date-picker>
          <div class="text-danger">
            {{ field_errors["data_final_monta"] }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-sm-12 col-xl-9 mb-3">
      <label>Taur</label>

      <span
        *ngIf="!disabledFields['taur_id']"
        class="mdi mdi-refresh cursor-pointer text-blue fs-4 ml-1"
        (click)="getListaTauri()"
      >
      </span>

      <div class="d-flex">
        <div class="flex-grow-1">
          <ng-select
            [items]="listaTauri"
            formControlName="taur_id"
            bindValue="id"
            placeholder="Introduceți matricol taur"
            [ngClass]="{
              disabled: disabledFields['taur_id'],
              'is-invalid': field_errors['taur_id']
            }"
            (change)="selectTaur($event)"
          >
            <ng-template ng-label-tmp ng-option-tmp let-item="item">
              <div class="row">
                <div
                  class="col-auto d-flex align-items-center justify-content-center"
                >
                  <div class="box-mascul">M</div>
                  <div class="color-mascul">{{ item["numarmatricol"] }}</div>
                  <div class="ml-2">{{ item["rasa"] }}</div>
                  <div *ngIf="item['codtaur']" class="ml-2">
                    {{ item["codtaur"] }}
                  </div>
                  <div *ngIf="item['nume']" class="ml-2">
                    {{ item["nume"] }}
                  </div>
                </div>

                <div class="col-sm-12 col-md-auto px-0">
                  <span
                    *ngFor="let error of item['errors']"
                    class="badge badge-danger p-1 mr-2"
                  >
                    {{ error }}
                  </span>
                  <span
                    *ngFor="let warning of item['warnings']"
                    class="badge badge-warning text-dark p-1 mr-2"
                  >
                    {{ warning }}
                  </span>
                </div>
              </div>
            </ng-template>
          </ng-select>

          <small
            *ngIf="!disabledFields['taur_id']"
            class="form-text text-muted"
          >
            <div class="mb-2">
              <span>
                Taurul se poate alege după ce s-a ales Data de start
              </span>
            </div>
          </small>

          <div class="text-danger">{{ field_errors["taur_id"] }}</div>

          <div
            *ngFor="let error of taurErrors"
            class="alert alert-danger"
            role="alert"
          >
            {{ error }}
          </div>
          <div
            *ngFor="let warning of taurWarnings"
            class="alert alert-warning"
            role="alert"
          >
            {{ warning }}
          </div>
        </div>

        <a
          *ngIf="form.value.taur_id"
          [routerLink]="'/dashboard/animal/' + form.value.taur_id"
          target="_blank"
          class="ml-2 fs-3"
          title="Pagina animalului"
          ><i class="mdi mdi-open-in-new mr-1"></i
        ></a>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 mb-3">
      <label class="mb-1">Autorizație Montă</label>

      <table
        *ngIf="autorizatiiMonta && autorizatiiMonta.length > 0"
        class="list-items-table"
      >
        <thead>
          <th></th>
          <th>Număr / Dată</th>
          <th>Emitent</th>
          <th>Perioada</th>
          <th>Fișier</th>
        </thead>
        <tbody>
          <tr *ngFor="let autorizatie of autorizatiiMonta; let index = index">
            <td>
              <input
                type="checkbox"
                [checked]="form.value.autorizatie_id === autorizatie.id"
                (click)="selectAutorizatie($event, autorizatie.id)"
                [ngClass]="{
                  disabled: disabledFields['autorizatie_id']
                }"
              />
            </td>
            <td>
              {{ autorizatie.nr_document }} /
              {{ autorizatie.data_document_dmy }}
            </td>
            <td>{{ autorizatie.emitent }}</td>
            <td>
              {{ autorizatie.data_inceput_dmy }} -
              {{ autorizatie.data_sfarsit_dmy }}
            </td>
            <td>
              <div *ngIf="autorizatie.file_name">
                <span
                  class="file-button"
                  (click)="downloadAutorizatieFile(autorizatie)"
                >
                  {{ autorizatie.file_name }}
                </span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="text-danger">{{ field_errors["autorizatie_id"] }}</div>
    </div>
  </div>

  <div class="row">
    <div class="col-12 col-xl-9 mb-3">
      <label>Femele</label>

      <span
        *ngIf="!disabledFields['femele_ids']"
        class="mdi mdi-refresh cursor-pointer text-blue fs-4 ml-1"
        (click)="getListaFemele()"
      >
      </span>

      <ng-container
        *ngFor="let femela of listaFemeleSelectate; let index = index"
      >
        <div class="row mb-2">
          <div
            class="col-auto d-flex align-items-center justify-content-center"
          >
            <div class="mr-3">{{ index + 1 }}</div>
            <div class="box-femela">F</div>
            <div class="color-femela">{{ femela["numarmatricol"] }}</div>
            <div class="ml-2">{{ femela["rasa"] }}</div>
            <div *ngIf="femela['nume']" class="ml-2">{{ femela["nume"] }}</div>
          </div>

          <div
            *ngIf="!disabledFields['femele_ids']"
            class="col-auto d-flex align-items-center justify-content-center"
          >
            <i
              class="mdi mdi-close-circle text-danger fs-3 cursor-pointer"
              title="Șterge"
              (click)="deleteFemela(index)"
            >
            </i>
          </div>

          <div
            class="col-auto d-flex align-items-center justify-content-center"
          >
            <a
              *ngIf="femela['id']"
              [routerLink]="'/dashboard/animal/' + femela['id']"
              target="_blank"
              class="ml-2 fs-3"
              title="Pagina animalului"
              ><i class="mdi mdi-open-in-new mr-1"></i
            ></a>
          </div>
        </div>
      </ng-container>

      <ng-select
        #elementFemela
        *ngIf="!disabledFields['femele_ids']"
        [items]="listaFemele"
        bindValue="id"
        placeholder="Introduceți matricol femelă"
        [ngClass]="{
          disabled: disabledFields['femele_ids'],
          'is-invalid': field_errors['femele_ids']
        }"
        (change)="selectFemela(elementFemela, $event)"
      >
        <ng-template ng-label-tmp ng-option-tmp let-item="item">
          <div class="row">
            <div
              class="col-auto d-flex align-items-center justify-content-center"
            >
              <div class="box-femela">F</div>
              <div class="color-femela">{{ item["numarmatricol"] }}</div>
              <div class="ml-2">{{ item["rasa"] }}</div>
              <div *ngIf="item['nume']" class="ml-2">{{ item["nume"] }}</div>
            </div>

            <div class="col-sm-12 col-md-auto px-0">
              <span
                *ngFor="let error of item['errors']"
                class="badge badge-danger p-1 mr-2"
              >
                {{ error }}
              </span>
              <span
                *ngFor="let warning of item['warnings']"
                class="badge badge-warning text-dark p-1 mr-2"
              >
                {{ warning }}
              </span>
            </div>
          </div>
        </ng-template>
      </ng-select>

      <small *ngIf="!disabledFields['femele_ids']" class="form-text text-muted">
        <div class="mb-2">
          <span>
            Femela se poate alege după ce s-a ales Data de start și Taur
          </span>
        </div>
      </small>

      <div class="text-danger">{{ field_errors["femele_ids"] }}</div>
    </div>
  </div>
</div>
